import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { CurrentUserService } from '../services/current-user.service';
import { ScopeService } from '../services/scope/scope-service';
import { SCOPES } from '../services/scope/scope-constants';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private currentUserService = inject(CurrentUserService);
  private scopeService = inject(ScopeService);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }
    if (!this.currentUserService.isLoggedIn()) {
      return this.router.createUrlTree(['/login']);
    }

    const userScopes = this.scopeService.getUserScopes();
    const isCustomer = userScopes.includes(SCOPES.PHARMACIES.CANCEL_REQUEST);

    const fullUrl = route.pathFromRoot.map((r) => r.url.map((segment) => segment.toString()).join('/')).join('/');

    if (fullUrl.includes('admin') && isCustomer) {
      return this.router.createUrlTree(['/user']);
    }

    if (fullUrl.includes('user') && !isCustomer) {
      return this.router.createUrlTree(['/admin']);
    }

    return true;
  }
}
